<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="800">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Facturas del Evento Masivo</v-toolbar>
        <v-card-text>
          <v-select
            v-model="docsector"
            :items="docssector"
            label="Documento Sector:"
            :disabled="loading"
            item-value="id"
            class="mt-4"
            outlined
            dense
            hide-details
          />

          <v-data-table
            :headers="headers"
            :items="desserts"
            :loading="loading"
            sort-by="calories"
            class="elevation-0 pa-0 mt-2"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title> Facturas de este evento </v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:[`item.opciones`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-1" small v-bind="attrs" v-on="on" @click="verItem(item)">
                    mdi-eye
                  </v-icon>
                </template>
                <span> Ver Factura </span>
              </v-tooltip>
            </template>
          </v-data-table>

          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>

      <div>
        <EventoViewFactura ref="verfacturaevento" />
      </div>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  import EventoViewFactura from '@/views/recibos/esignificativos/eventoviewfactura.vue';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingtipoDocumentoSector: false,
        msg: '',
        tdocs: [],
        xitem: null,
        docsector: null,
        docssector: [
          { id: 1, text: 'COMPRA Y VENTA' },
          { id: 11, text: 'SECTOR EDUCATIVO' },
        ],
        headers: [
          { text: 'nombre Razon Social', value: 'nombreRazonSocial' },
          { text: 'periodo Facturado', value: 'periodoFacturado' },
          { text: 'numero Factura', value: 'numeroFactura' },
          { text: 'numero Documento', value: 'numeroDocumento' },
          { text: 'Monto', value: 'montoTotal' },
          { text: 'Opciones', value: 'opciones', sortable: false, width: 100 },
        ],
        desserts: [],
      };
    },
    components: { EventoViewFactura },
    watch: {
      docsector: function() {
        if (this.docsector) this.geteventosig(this.xitem.id);
      },
    },
    methods: {
      openmodal(item) {
        this.msg = '';
        this.dialog = true;
        this.xitem = item;
        this.docsector = null;
        this.desserts = [];
        window.console.log(item);
        //this.geteventosig(item.id);
        //this.getdocumentossector();
        this.geteventosig(item.id);
      },
      getdocumentossector() {
        //this.tdocs.push({codigo:1,text:""});
        let vue = this;
        this.loadingtipoDocumentoSector = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/tiposdocumentos`,
          headers: {
            'Content-Type': 'application/json',
            //apikey: '4265269017',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.codigo = parseInt(x.codigo_clasificador_SIN);
              x.text = `${x.codigo_clasificador_SIN} (${x.descripcion_SIN})`;
            });
            vue.tdocs = data;
            vue.loadingtipoDocumentoSector = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingtipoDocumentoSector = false;
          });
      },
      geteventosig(idevento) {
        if (!this.docsector) return;
        this.loading = true;
        this.desserts = [];
        let numDocSec = this.docsector; // sector academico
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventomasivo/${idevento}/documentoSector/${numDocSec}/ventas`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('geteventosig:', data);
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      verItem(item) {
        this.$refs.verfacturaevento.openmodal(item);
      },
    },
  };
</script>
